




import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { BEAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEAttribute';
import { EntityAttributesDTO } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EntityAttributesDTO';
import { MDService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/MDService';
import { EVOAttribute } from '@/api/com/MetaPattern/MDA/MD/UIModel/EVOAttribute';
import CacheItem from '@/libs/com/MetaPattern/Product/IDE/Util/CacheItem';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import PGRowElementSelect from './PGRowElementSelect.vue';

@Component({
  components: {
    PGRowElementSelect
  }
})
/** 绑定实体属性：指定实体的属性选择，包括基类及关联属性 */
export default class PGRowBindingBEAttributeValue extends Vue {
  @Prop() private value!: string;
  @Prop() private isEditable!: boolean;
  @Prop() private elementDesignId!: string; // 实体属性的设计期ID
  private attributes: Array<BEAttribute>;

  constructor() {
    super();
    this.attributes = null;
  }

  valueChanged(newValue: string, newElement: BaseElement): void {
    this.$emit('valueChanged', newValue, newElement);
  }

  get options() {
    if (this.attributes === null) {
      const attribute = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === this.elementDesignId) as EVOAttribute;
      if (attribute) {
        const entityId = attribute.viewObject.bindingBEEntity_ID;
        if (entityId !== '') {
          const result = this.$store.getters['ObjectCache/cacheItem'](entityId + 'AllAttributes');
          if (!ValidateHelper.IsNotNullOrUndefined(result)) {
            MDService.GetAllAttributesAsync(entityId)
              .then((dto: EntityAttributesDTO) => {
                this.attributes = dto.attributes;
                const cacheItem = new CacheItem(entityId + 'AllAttributes', this.attributes, 60);
                this.$store.dispatch('ObjectCache/addItemAction', cacheItem);
              });
          } else {
            this.attributes = result as Array<BEAttribute>;
          }
        }
      }
    }
    return this.attributes;
  }
}
